const NAME = 'circle';

const VIEWBOX = '0 0 50 50';

const CONTENTS = `
  <circle cx="25" cy="25" r="24"/>
`;

const SYMBOL_MARKUP = `<symbol id="tn-syos-seat-map-icon-${NAME}" viewBox="${VIEWBOX}">${CONTENTS}</symbol>`;

function getSvgMarkup(label = 'Circle') {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${VIEWBOX}" focusable="false" role="img" aria-label="${label}">${CONTENTS}</svg>`;
}

export default {
  getSvgMarkup,
  SYMBOL_MARKUP,
};



// WEBPACK FOOTER //
// ./src/syos/seatIcons/Circle.js